const mediaItems = [
  {
    id: 1,
    title: '韩漫推荐：2026年必追神作盘点',
    desc: '一口气看完10部年度最值得追的韩漫，本本都是口碑爆款！',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20video%20thumbnail%20style%20illustration%20with%20warm%20coral%20and%20cream%20palette%2C%20dynamic%20composition%20with%20play%20button%20element%2C%20energetic%20atmosphere%2C%20comic%20art%20style%2C%20no%20text&width=640&height=360&seq=media-thumb-01&orientation=landscape',
    duration: '15:32',
  },
  {
    id: 2,
    title: '国漫崛起之路：从斗破到绝世神医',
    desc: '见证国漫玄幻题材的辉煌崛起，经典作品全解析。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20video%20thumbnail%20style%20illustration%20with%20warm%20coral%20and%20cream%20palette%2C%20dynamic%20composition%20with%20play%20button%20element%2C%20energetic%20atmosphere%2C%20comic%20art%20style%2C%20no%20text&width=640&height=360&seq=media-thumb-02&orientation=landscape',
    duration: '22:18',
  },
  {
    id: 3,
    title: '日漫新番导视：夏季追更全攻略',
    desc: '本季日漫新作一网打尽，奇幻冒险校园恋爱全都有。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20video%20thumbnail%20style%20illustration%20with%20warm%20coral%20and%20cream%20palette%2C%20dynamic%20composition%20with%20play%20button%20element%2C%20energetic%20atmosphere%2C%20comic%20art%20style%2C%20no%20text&width=640&height=360&seq=media-thumb-03&orientation=landscape',
    duration: '18:45',
  },
  {
    id: 4,
    title: '下拉式阅读体验：为什么大家都在用',
    desc: '告别传统翻页，感受羞羞漫画独创下拉式阅读的极致流畅体验。',
    imgUrl: 'https://readdy.ai/api/search-image?query=Manga%20video%20thumbnail%20style%20illustration%20with%20warm%20coral%20and%20cream%20palette%2C%20dynamic%20composition%20with%20play%20button%20element%2C%20energetic%20atmosphere%2C%20comic%20art%20style%2C%20no%20text&width=640&height=360&seq=media-thumb-04&orientation=landscape',
    duration: '10:56',
  },
];

export default function Media() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
            <i className="ri-play-circle-line text-accent-500 text-xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精彩视频</h2>
        </div>
        <p className="text-foreground-500 text-sm md:text-base mb-8 ml-[52px]">漫画推荐视频，发现更多宝藏作品</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden bg-background-200">
                <img
                  src={item.imgUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-accent-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-xs whitespace-nowrap">{item.duration}</span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 mb-1.5 group-hover:text-accent-500 transition-colors line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}